import { Navigate, useParams } from 'react-router-dom';

/** Old reseller-card editor URLs land on the partner's Pricing → Rate card leaf. */
export function LegacyResellerCardRedirect() {
  const { resellerId } = useParams();
  return <Navigate to={`/partners/${resellerId ?? ''}?tab=priceCard`} replace />;
}
